import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-assign-to-character',
  templateUrl: './assign-to-character.component.html',
  styleUrl: './assign-to-character.component.scss'
})
export class AssignToCharacterComponent {

  public list: Array<any> = [];
  public roleList: any = [];
  public selected: any = null;
  public imgUrl: string = environment.ImageUrl

  constructor(
    private auth: AuthServiceService,
    private modalService: NgbModal,
    private toastr: ToastrService) {

  }

  ngOnInit(): void {
    this._getList();
    this._getAllRoleList();
  }

  private _getList() {
    this.auth.getAllRoleCharacter().subscribe((resp: ApiResponse) => {
      this.list = resp.body;
    })
  }

  private _getAllRoleList() {
    this.auth.getAllMemberRole().subscribe((resp: ApiResponse) => {
      this.roleList = resp.body;
    })
  }

  public onRoleChange(value) {
    this.selected = value;
  }

  public addRoleToCharacter(profileCharacterId, currentRoleList) {
    if (this.selected) {
      if (currentRoleList.length >= 1) {
        this.toastr.error("single Role can be added!");
      }
      else if (currentRoleList.filter((i) => i.roleId == this.selected && i.profileCharacterId == profileCharacterId).length > 0) {
        this.toastr.error("Role Already Present!");
      } else {
        this.auth.addRoleCharacter({ roleId: this.selected, profileCharacterId: profileCharacterId }).subscribe((resp: ApiResponse) => {
          this.toastr.success(resp.message);
          this._getList();
          this.selected = null;
        }, (error: any) => {
          this.toastr.error("Error Please try again!");
        });
      }
    } else {
      this.toastr.error("Select Permissions !");
    }
  }

  public deleteMemberCharacterRelationship(id: any) {
    this.auth.deleteRoleCharacter(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this._getList();
    }, ({ error }) => {
      this.toastr.error("Remove All Dependency before Deleting!");
    })
  }

}
